import React, { useState, useContext } from "react"
import styled from "styled-components"
import Logo from "../logo/logo"
import Search from "../search/search"
import Menu from "../menu/menu"
import Button from "../button/button"
import { Link, navigate } from "gatsby"
import { FaCog, FaWindowClose, FaLock, FaUser } from "react-icons/fa"
import { InstantSearch } from "react-instantsearch-dom"
import algoliasearch from "algoliasearch/lite"
import { useAuth } from "react-use-auth"
import Tippy from "@tippy.js/react"
import "tippy.js/dist/tippy.css"
import { UserContext } from "../../state"

const Header = ({ children }) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false)
  const { login } = useAuth()
  const [userState] = useContext(UserContext)

  const openMenu = () => {
    setMenuIsOpen(true)
  }

  const closeMenu = () => {
    setMenuIsOpen(false)
  }
  const searchClient = algoliasearch(
    "ICYB1ZCH0J",
    "6a96ce42af94a33d9cff63221c98e5e8"
  )

  return (
    <StyledHeader className="hide-in-print">
      <LeftSection>
        <Link to="/">
          <Logo color="white" />
        </Link>
      </LeftSection>
      <CenterSection>
        {userState && userState.isApproved && (
          <InstantSearch
            searchClient={searchClient}
            indexName="humphree"
            refresh
          >
            <Search />
          </InstantSearch>
        )}
      </CenterSection>
      <RightSection>
        {userState && userState.isApproved ? (
          <Button secondary size="small" dispatch={() => navigate("/account")}>
            <FaUser /> {userState.username}
          </Button>
        ) : userState && userState.isApproved === false ? null : (
          <Button secondary size="small" dispatch={login}>
            <FaLock /> Log in
          </Button>
        )}
        {menuIsOpen ? (
          <MenuDeactivator onClick={closeMenu} />
        ) : (
          <Tippy arrow={false} content="Menu">
            <div
              /* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */
              tabIndex="0"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <MenuActivator onClick={openMenu} />
            </div>
          </Tippy>
        )}
        <Menu active={menuIsOpen} close={closeMenu}>
          {children}
        </Menu>
      </RightSection>
    </StyledHeader>
  )
}

export default Header

const StyledHeader = styled.div`
  position: fixed;
  width: 100%;
  top: 0;
  padding: 0 20px;
  background-color: #222;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  z-index: 3;

  @media only screen and (max-width: 820px) {
    padding: 10px;
  }
`
const LeftSection = styled.div`
  flex: 0 0 20%;
  padding-right: 20px;

  svg {
    max-width: 180px;
  }

  @media only screen and (max-width: 820px) {
    flex-basis: 50%;
  }
`
const CenterSection = styled.div`
  flex: 1 1 auto;
  position: relative;

  @media only screen and (max-width: 820px) {
    order: 3;
    flex-basis: 100%;
    margin-top: 8px;
  }
`
const RightSection = styled.div`
  flex: 0 1 20%;
  text-align: right;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media only screen and (max-width: 820px) {
    flex-basis: 50%;
  }
`

const MenuActivator = styled(FaCog)`
  color: #fff;
  cursor: pointer;
  height: 35px;
  width: 35px;
  padding: 7px;
  margin: 15px -10px 15px 10px;
  border-radius: 100px;
  transition: background-color 50ms ease-in-out;

  .theme-dark & {
    color: #fff;
  }

  &:hover,
  &:active,
  &:focus {
    outline: none;
    background-color: #ffffff30;
  }
`

const MenuDeactivator = styled(FaWindowClose)`
  color: #fff;
  cursor: pointer;
  height: 35px;
  width: 35px;
  padding: 7px;
  margin: 15px -10px 15px 10px;
  border-radius: 100px;

  .theme-dark & {
    color: #fff;
  }

  &:hover,
  &:active,
  &:focus {
    outline: none;
    background-color: #ffffff30;
  }
`
